import axios from 'axios'

const PLACE_POPULATE = 'populate[placecriteria][populate]=criteria&populate[type]=true&populate[user]=true'
const CRITERIA_POPULATE = 'populate=typeplaces'

const unwrap = (res) => (res && res.data && 'data' in res.data ? res.data.data : res.data)

class Api {
  constructor() {
    this.apiURL = process.env.REACT_APP_API_URL
    this.getConfig = this.getConfig.bind(this)
  }
  getConfig() {
    const jwt = localStorage.getItem('jwt')
    return jwt ? {
      headers: {
        'Authorization': `Bearer ${jwt}`,
        'Accept-Language': 'en_US'
      }
    } : {
      headers: {
        'Accept-Language': 'en_US'
      }
    }
  }
  checkMe = () => {
    if (localStorage.getItem('jwt')) {
      return new Promise((resolve, reject) => axios
        .get(this.apiURL + '/api/users/me', this.getConfig())
        .then(res => {
          resolve(res.data)
        })
        .catch(error => {
          localStorage.removeItem('jwt')
          reject(error)
        })
      )
    } else {
      return new Promise((resolve, reject) => reject())
    }
  }
  deleteUser = (id, places) => {
    if (localStorage.getItem('jwt')) {
      return new Promise((resolve, reject) => {
        Promise.all(
          places.map(p => (p.placecriteria || []).map(pc =>
            axios.delete(this.apiURL + '/api/placecriterias/' + pc.documentId, this.getConfig())
          )),
          places.map(p =>
            axios.delete(this.apiURL + '/api/places/' + p.documentId, this.getConfig())
          ),
          axios.delete(this.apiURL + '/api/users/' + id, this.getConfig())
        ).then(res => {
          localStorage.removeItem('jwt')
          resolve(res)
        }).catch(error => {
          reject(error && error.response && error.response.data && (error.response.data.error || error.response.data))
        })
      })
    } else {
      return new Promise((resolve, reject) => reject())
    }
  }
  login = (username, password) => {
    return new Promise((resolve, reject) => axios
      .post(this.apiURL + '/api/auth/local', {
        identifier: username,
        password: password,
      }, this.getConfig())
      .then(res => {
        localStorage.setItem('jwt', res.data.jwt)
        resolve(res.data)
      })
      .catch(error => {
        localStorage.removeItem('jwt')
        reject(error)
      })
    )
  }
  loginWithFacebook = (search) => {
    return new Promise((resolve, reject) => axios
      .get(this.apiURL + '/api/auth/facebook/callback' + search, this.getConfig())
      .then(res => {
        localStorage.setItem('jwt', res.data.jwt)
        resolve(res.data)
      })
      .catch(error => {
        localStorage.removeItem('jwt')
        reject(error)
      })
    )
  }
  fetchAllTypesPlaces = () => {
    return new Promise((resolve, reject) => axios
      .get(this.apiURL + '/api/typeplaces', this.getConfig())
      .then(res => resolve(unwrap(res)))
      .catch((e) => {
        console.log(e)
        reject(e)
      })
    )
  }
  fetchAllUserPlaces = () => {
    return new Promise((resolve, reject) => axios
      .get(this.apiURL + '/api/places?' + PLACE_POPULATE, this.getConfig())
      .then(res => {
        const items = unwrap(res) || []
        const data = items.map(p => {
          if (typeof p.coordinates === 'string') {
            const coords = p.coordinates.split(',')
            p.latitude = parseFloat(coords[0])
            p.longitude = parseFloat(coords[1])
          }
          return p
        })
        resolve(data)
      })
      .catch((e) => {
        console.log(e)
        reject(e)
      })
    )
  }
  fetchAllCriteria = () => {
    return new Promise((resolve, reject) => axios
      .get(this.apiURL + '/api/criterias?' + CRITERIA_POPULATE, this.getConfig())
      .then(res => resolve(unwrap(res)))
      .catch((e) => {
        console.log(e)
        reject(e)
      })
    )
  }
  placeToggleFavorite = (place) => {
    return new Promise((resolve, reject) => axios
      .put(this.apiURL + '/api/places/' + place.documentId + '?' + PLACE_POPULATE, {
        data: { favorite: !place.favorite }
      }, this.getConfig())
      .then(res => resolve(unwrap(res)))
      .catch((e) => {
        console.log(e)
        reject(e)
      })
    )
  }
  register = (username, email, password) => {
    return new Promise((resolve, reject) => axios
      .post(this.apiURL + '/api/auth/local/register', {
        username,
        email,
        password,
      })
      .then(res => {
        localStorage.setItem('jwt', res.data.jwt)
        resolve(res.data)
      })
      .catch(error => {
        localStorage.removeItem('jwt')
        reject(error)
      })
    )
  }
  removePlace = (placeToRemove) => {
    return new Promise((resolve, reject) => {
      const placecriteria = placeToRemove.placecriteria || []
      Promise.all(
        placecriteria.map(pc =>
          axios.delete(this.apiURL + '/api/placecriterias/' + pc.documentId, this.getConfig())
        )
      ).then(() => {
        axios.delete(this.apiURL + '/api/places/' + placeToRemove.documentId, this.getConfig())
          .then(() => resolve(placeToRemove.id))
          .catch((e) => {
            console.log(e)
            reject(e)
          })
      }).catch((e) => {
        console.log(e)
        reject(e)
      })
    })
  }
}

export default Api
